import { Box, Typography, makeStyles } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router";

import { CustomButton } from "@/components/Button";
import { buildDiagnosisFlowSteps } from "@/components/diagnosis/diagnosisFlowStepDefinitions";
import DiagnosisFlowSteps from "@/components/diagnosis/DiagnosisFlowSteps";
import { DiagnosisLayout, diagnosisActionStyles } from "@/layouts/DiagnosisLayout";
import theme from "@/theme";

import CompletionCharacter from "@assets/image/investment_style_completion_character.png";

// 投資力診断・投資スタイルの作成は完了済み(✓)、3段階目（プランナー）はこれから(③)。
const COMPLETION_STEPS = buildDiagnosisFlowSteps(["completed", "completed", "upcoming"], "diagnosis");

const useStyles = makeStyles(() => ({
  "@keyframes completionEnter": {
    from: { opacity: 0, transform: "translateY(12px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes characterEnter": {
    from: { opacity: 0, transform: "translateY(18px) scale(0.95)" },
    to: { opacity: 1, transform: "translateY(0) scale(1)" },
  },
  reveal: {
    animation: "$completionEnter 480ms cubic-bezier(0.22, 1, 0.36, 1) both",
    "@media (prefers-reduced-motion: reduce)": {
      "&&": { animation: "none" },
      "&& > li": { animation: "none" },
    },
  },
  characterReveal: {
    animationName: "$characterEnter",
    animationDuration: "680ms",
  },
  headingReveal: { animationDelay: "120ms" },
  stepsReveal: {
    animationDelay: "220ms",
    "& > li": { animation: "$completionEnter 480ms cubic-bezier(0.22, 1, 0.36, 1) both" },
    "& > li:nth-child(1)": { animationDelay: "260ms" },
    "& > li:nth-child(2)": { animationDelay: "380ms" },
    "& > li:nth-child(3)": { animationDelay: "500ms" },
  },
  actionsReveal: {
    animationDelay: "620ms",
    "&:focus-within": { animation: "none" },
  },
  heading: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.3,
    textAlign: "center",
    color: theme.palette.text.primary,
    margin: "24px 0",
    [theme.breakpoints.up("md")]: { fontSize: 24 },
  },
  characterWrap: {
    display: "flex",
    justifyContent: "center",
    margin: 0,
  },
  // 画像は背景の淡い形を含めて書き出した 2 倍サイズ（609×454）。表示は Figma と同じ幅 304
  characterImage: {
    width: 304,
    maxWidth: "100%",
    height: "auto",
  },
  buttonWrap: {
    ...diagnosisActionStyles,
  },
}));

export const DiagnosisInvestmentStyleCompletionPage: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <DiagnosisLayout>
      <Box className={`${classes.characterWrap} ${classes.reveal} ${classes.characterReveal}`}>
        <img
          src={CompletionCharacter}
          alt="診断完了キャラクター（3つのステップのうち2つ目まで進んだ様子）"
          className={classes.characterImage}
        />
      </Box>

      <Typography className={`${classes.heading} ${classes.reveal} ${classes.headingReveal}`}>
        診断が完了しました！
      </Typography>

      <DiagnosisFlowSteps
        steps={COMPLETION_STEPS}
        animateCompletion
        completionDelayMs={900}
        className={`${classes.reveal} ${classes.stepsReveal}`}
      />

      <Box className={`${classes.buttonWrap} ${classes.reveal} ${classes.actionsReveal}`}>
        {/* 結果は「あなたの投資スタイル」と呼ぶ（HOME_SUBMIT_STEP の文言と同じ） */}
        <CustomButton
          type="button"
          tone="trust"
          buttonSize="L"
          fullWidth
          onClick={() => history.push("/investment_style_diagnosis/result")}
        >
          あなたの投資スタイルを見る
        </CustomButton>
      </Box>
    </DiagnosisLayout>
  );
};
